export const FILE_UPLOAD_LABELS = {
  HEADER: 'File Upload',
  NOTE: '*Note: All files must be',
  CSV: 'CSV',
  TXT: 'TXT',
  XLS: '.XLS',
  DRAG_FILE: 'Drag your files here',
  OR: 'Or',
  BROWSE_FILES: 'Browse Files',
  LOADING: 'Loading',
  UPLOADED: 'Uploaded',
  CANCEL: 'cancel',
  SUBMIT: 'submit',
  TRY_AGAIN: 'Try Again',
  REUPLOAD: 'Re-Upload',
  UNABLE_UPLOAD: 'Unable to Upload',
  INVALID_FILE_FORMAT: '*Invalid file type!',
  INVALID_FILE: '*Invalid file!',
  INVALID_FILE_DATA:
    '*Data Error!  Rows must contain ONLY data in this order: %a',
  CLOSE_MODAL: {
    HEADER: $localize`Close Window`,
    LINE1: $localize`Close the window?`,
    LINE2: $localize`Your changes will not be saved.`,
    CONFIRM_BUTTON: $localize`Yes`,
    REJECT_BUTTON: $localize`No`,
  },
};

export enum UploadStatus {
  IN_PROGRESS = 'inProgress',
  SUCCESS = 'success',
  FAILED = 'failed',
}

export enum FileParseType {
  WEIGHT_AUDIT,
  SIZE_AUDIT,
  WAREHOUSE_SCAN,
  TRACKINGNUMBER_ONLY,
}

export const TRACKING_NUMBER_VALID_FORMAT = 'Tracking Numbers';

export type FileType = {
  progress: number;
  fileItem: File | null | never;
};

export type FileData = {
  file: FileType;
  trackingNumber?: string;
  uploadStatus?: UploadStatus;
  isInvalidFile?: boolean;
  sci?: boolean;
  fileType?: FileParseType;
};

export type FileReturn = {
  fileName: string;
  fileSize: number;
  returnData: ParsedFileData[][];
};

export type ParsedFileData = {
  trackingNumber: string;
  location?: string;
  weight?: string;
  length?: string;
  width?: string;
  height?: string;
  unit?: string;
  uow?: string;
};
